/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum UserProductRelatedEntityType {
  Appointment = "Appointment",
  UserQuiz = "UserQuiz",
}

export enum StackHolderType {
  Organization = "Organization",
  ConsultantTeam = "ConsultantTeam",
  ServiceStackHolder = "ServiceStackHolder",
  Performer = "Performer",
}

export enum StackHolderPaymentStatus {
  Unpaid = "Unpaid",
  Paid = "Paid",
}

export enum SortOrders {
  Ascending = "Ascending",
  Descending = "Descending",
}

/** نوع وقت رزرو را تعیین می کند */
export enum ReservationIntervalType {
  Fixed = "Fixed",
  Online = "Online",
  Unscheduled = "Unscheduled",
}

export enum ProductUnit {
  Daily = "Daily",
  OnDemand = "OnDemand",
}

export enum ProductType {
  Planning = "Planning",
  PhoneCounseling = "PhoneCounseling",
  VerbalConsulting = "VerbalConsulting",
  TelegramCounseling = "TelegramCounseling",
  ChatCounseling = "ChatCounseling",
  Quiz = "Quiz",
  CounselorManualDelivery = "CounselorManualDelivery",
}

export enum ProductAttributeTypes {
  Counselor = "Counselor",
  Duration = "Duration",
  Goal = "Goal",
  PeriodicQuantity = "PeriodicQuantity",
  FixedQuantity = "FixedQuantity",
}

export enum InvoiceTypes {
  Purchase = "Purchase",
  Refund = "Refund",
}

export enum InvoiceStatus {
  Pending = "Pending",
  Canceled = "Canceled",
  Postponed = "Postponed",
  ReturnToUser = "ReturnToUser",
  Successful = "Successful",
  Unpayable = "Unpayable",
  Deleted = "Deleted",
}

/** جهت حرکت را تعیین می کند */
export enum InfiniteScrollDirection {
  Forward = "Forward",
  Backward = "Backward",
}

export enum HtmlFormMethods {
  Get = "Get",
  Post = "Post",
}

export enum FeedbackType {
  Liked = "Liked",
  Disliked = "Disliked",
}

export enum FeedbackOperation {
  Insert = "Insert",
  Remove = "Remove",
}

/** انواع جلسات مورد پشتیبانی توسط مشاور */
export enum CounselorSupportedAppointmentTypes {
  Phone = "Phone",
  Video = "Video",
  InPerson = "InPerson",
}

export enum ComplexPackageTypes {
  Free = "Free",
  Counseling = "Counseling",
  Commando = "Commando",
  Accelerated = "Accelerated",
  Customizable = "Customizable",
  Book = "Book",
}

/** نحوه‌ی قرار گرفتن یک کالای بسته در فاکتور را مشخص می‌کند */
export enum ComplexPackagePlainProductInclusionTypes {
  Conditional = "Conditional",
  Always = "Always",
}

export enum ComplexPackageConfigurationSelection {
  UnProvided = "UnProvided",
  Selected = "Selected",
  Sampled = "Sampled",
}

/** مشخص می‌کند خرید کنونی کدام نوع است */
export enum ComplexPackageActionTypes {
  None = "None",
  Extending = "Extending",
  CounselorCandidates = "CounselorCandidates",
  Customize = "Customize",
  StartFree = "StartFree",
}

/** Command for client to do for upgrading itself */
export enum ClientVersionCommands {
  Nothing = "Nothing",
  Upgrade = "Upgrade",
}

export enum BankAccountPaymentMethod {
  Cash = "Cash",
  Credit = "Credit",
  Installment = "Installment",
}

export enum ApplicantGoalType {
  CounselingSubject = "CounselingSubject",
  Branch = "Branch",
}

export interface ActiveProductPortable {
  Title?: string | null;
  Description?: string | null;
  /** @format int32 */
  Quantity?: number;
  Unit?: string | null;
}

export interface ApplicantActiveProductsOutput {
  ActiveProducts?: ActiveProductPortable[] | null;
}

export interface ApplicantGoal {
  Type?: ApplicantGoalType;
  /** @format int32 */
  EntityId?: number;
}

export interface ApplyDiscountCodeInput {
  /** @format int32 */
  InvoiceId?: number;
  Code?: string | null;
  PaymentMethod?: BankAccountPaymentMethod;
  /** @format uuid */
  ConsulteeId?: string | null;
}

export interface ApplyDiscountCodeOutput {
  Invoice?: InvoiceCoreWithComplexPackagePortable;
}

export interface BankAccountPaymentMethodPortable {
  /** @format int32 */
  BankAccountId?: number;
  PaymentMethod?: BankAccountPaymentMethod;
  Title?: string | null;
  Selected?: boolean;
}

export interface CalculateComplexPackageInput {
  PurchaseConfig?: PurchaseComplexPackageComponent;
  CustomizedProducts?: CustomizedProductPortable[] | null;
  /** @format uuid */
  ConsulteeId?: string | null;
}

export interface CalculateComplexPackageOutput {
  ComplexPackage?: ComplexPackageCustomizedPortable;
  Invoice?: PackedInvoiceCoreWithItemsPortable;
  UpdatedProducts?: CustomizingProductPortable[] | null;
}

export interface CalculateInvoicePaymentDetailsInput {
  /** @format int32 */
  InvoiceId?: number;
  /** @format int32 */
  BankAccountId?: number;
  PaymentMethod?: BankAccountPaymentMethod;
  /** @format uuid */
  ConsulteeId?: string | null;
}

export interface CalculateInvoicePaymentDetailsOutput {
  Invoice?: InvoiceCoreWithComplexPackagePortable;
}

export interface CancelingInvoiceItemEntry {
  /**
   * شناسه آیتم فاکتور
   * @format int32
   */
  InvoiceItemId?: number;
  Name?: string | null;
  Code?: string | null;
  /**
   * شناسه محصول کاربر
   * @format int32
   */
  UserProductId?: number;
  /**
   * تاریخ آخرین بروزرسانی محصول کاربر
   * @format date-time
   */
  LasUserProductUpdated?: string;
  /**
   * شناسه محصول
   * @format int32
   */
  ProductId?: number;
  /**
   * تعداد خریدرای شده
   * @format int32
   */
  PurchasedQuantity?: number;
  /**
   * قیمت واحد
   * @format int32
   */
  UnitPrice?: number;
  /**
   * مبلغ پرداخت شده
   * @format int32
   */
  PaidAmount?: number;
  /**
   * مبلغ استردادی به داوطلب
   * @format int32
   */
  RefundAmount?: number;
  /**
   * تعداد استردادی به داوطلب
   * @format int32
   */
  RefundQuantity?: number;
}

export type CancellingInvoiceCoreWithItemsPortable = InvoiceCorePortable & {
  QuantityDiscount?: PriceComponent;
  WalletLockedAmount?: PriceComponent;
  CancelCurrentPlanAmount?: PriceComponent;
  Refundable?: PriceComponent;
  Items?: CancelingInvoiceItemEntry[] | null;
};

export interface ClientVersionPortable {
  /** @format int32 */
  ClientVersionId?: number;
  Type?: string | null;
  Vendor?: string | null;
  /** @format int32 */
  VersionNumber?: number;
  VersionName?: string | null;
  /** @format date-time */
  Released?: string | null;
  /** @format date-time */
  Expiration?: string | null;
  LandingUrl?: string | null;
  DownloadUrl?: string | null;
  UpgradeMessage?: string | null;
  ExpiredMessage?: string | null;
  PrereleaseMessage?: string | null;
}

export interface CommonQuestionPortable {
  /** @format int32 */
  CommonQuestionId?: number;
  /** @format int32 */
  Position?: number;
  Question?: string | null;
  Answer?: string | null;
  Labels?: string[] | null;
}

export interface ComplexPackageCommonInput {
  /** @format int32 */
  ComplexPackageId?: number;
  /** @format int32 */
  ContractDaysCount?: number | null;
  /** @format uuid */
  CounselorId?: string | null;
  Goal?: ApplicantGoal;
  GoalSelection?: ComplexPackageConfigurationSelection;
  /** @format int32 */
  GoalCounselorId?: number | null;
  Exam?: ExamComponent;
  /** @format uuid */
  FilledFormUniversalId?: string | null;
}

export type ComplexPackageCorePortable = ComplexPackageMinPortable & {
  /** @format int32 */
  Position?: number;
  Title?: string | null;
  Slug?: string | null;
  Subtitle?: string | null;
  LeadIcon?: string | null;
  LeadText?: string | null;
  IconUrl?: string | null;
  CssClass?: string | null;
  PictureCover?: string | null;
};

export interface ComplexPackageCounselorFieldOption {
  Label?: string | null;
  /** @format int32 */
  GoalCounselorId?: number;
  /** @format int32 */
  ExamId?: number | null;
  PricePrefix?: string | null;
  OriginalPrice?: PriceComponent;
  /** @format int32 */
  DiscountPercent?: number;
  TotalPrice?: PriceComponent;
}

export interface ComplexPackageCounselorOutput {
  /** @format int32 */
  ComplexPackageId?: number;
  CounselorSlug?: string | null;
  ComplexPackageSlug?: string | null;
  Title?: string | null;
  OwnerRole?: string | null;
  Badge?: string | null;
  Video?: string | null;
  Cover?: string | null;
  Description?: string | null;
  PricePrefix?: string | null;
  OriginalPrice?: PriceComponent;
  /** @format int32 */
  DiscountPercent?: number | null;
  TotalPrice?: PriceComponent;
  /** @format int32 */
  RemainingQuantity?: number | null;
  Capacity?: string | null;
  /** @format double */
  Rate?: number;
  /** @format int32 */
  RateCount?: number;
  Link?: string | null;
  Buyable?: boolean;
  DisableCounselor?: boolean;
  ComplexPackageType?: ComplexPackageTypes;
  GoalSelection?: ComplexPackageConfigurationSelection;
  Specifications?: string[] | null;
  Subjects?: string[] | null;
  Goals?: ComplexPackageCounselorFieldOption[] | null;
  Seo?: PageSeoDetail;
  Counselor?: CounselorPurchasePortable;
  Rates?: RatePortableInt32LimitedCountPreview;
  CommonQuestions?: CommonQuestionPortable[] | null;
  /** اطلاعات جهت ایجاد نظر را نگهداری می کند */
  ProductFeedback?: ProductFeedbackPortable;
  CurrentUser?: UserCorePortable;
}

export interface ComplexPackageCustomizedPortable {
  /** @format int32 */
  ComplexPackageId?: number;
  Type?: ComplexPackageTypes;
  /** @format int32 */
  Position?: number;
  Title?: string | null;
  Slug?: string | null;
  Subtitle?: string | null;
  LeadIcon?: string | null;
  LeadText?: string | null;
  IconUrl?: string | null;
  CssClass?: string | null;
  PictureCover?: string | null;
  Badge?: string | null;
  OwnerRole?: string | null;
  Gifts?: ComplexPackageGiftPortable[] | null;
}

export interface ComplexPackageFeaturePortable {
  Supported?: boolean;
  /** @format int32 */
  FeatureId?: number;
  /** @format int32 */
  ComplexPackageId?: number;
}

export type ComplexPackageFeatureWithComplexPackageAndFeaturePortable =
  ComplexPackageFeaturePortable & {
    Feature?: FeaturePortable;
    ComplexPackage?: ComplexPackageCorePortable;
  };

export interface ComplexPackageGiftPortable {
  /** @format int32 */
  ComplexPackageGiftId?: number;
  /** @format int32 */
  ComplexPackageId?: number;
  Icon?: string | null;
  Title?: string | null;
  /** @format int32 */
  PlainProductId?: number | null;
  /** @format int32 */
  Quantity?: number;
  /** @format int32 */
  Position?: number;
}

/** renamed to ComplexPackageItemPortable to explain that this record must be used as an item only in ComplexPackages */
export interface ComplexPackageItemPortable {
  /** @format int32 */
  ComplexPackageId?: number;
  Type?: ComplexPackageTypes;
  /** @format int32 */
  Position?: number;
  Title?: string | null;
  Slug?: string | null;
  Subtitle?: string | null;
  LeadIcon?: string | null;
  LeadText?: string | null;
  IconUrl?: string | null;
  CssClass?: string | null;
  PictureCover?: string | null;
  Badge?: string | null;
  PricePrefix?: string | null;
  Price?: PriceComponent;
  CallToAction?: string | null;
  Pickable?: boolean;
  /** مشخص می‌کند خرید کنونی کدام نوع است */
  ActionType?: ComplexPackageActionTypes;
  RequireConfirmGoal?: boolean;
  Gifts?: ComplexPackageGiftPortable[] | null;
  Features?: FeaturePortable[] | null;
}

export interface ComplexPackageMinPortable {
  /** @format int32 */
  ComplexPackageId?: number;
  Type?: ComplexPackageTypes;
}

export interface ComplexPackagePlainProductCorePortable {
  /** @format int32 */
  ComplexPackageId?: number;
  /** @format int32 */
  PlainProductId?: number;
  PickOptional?: boolean;
  PickDefault?: boolean;
  PickDisabled?: boolean;
}

export type ComplexPackagePlainProductPrivatePortable =
  ComplexPackagePlainProductCorePortable & {
    /** نحوه‌ی قرار گرفتن یک کالای بسته در فاکتور را مشخص می‌کند */
    InclusionType?: ComplexPackagePlainProductInclusionTypes;
    RequireReservation?: boolean;
  };

export type ComplexPackagePlainProductWithProductAndPackagePortable =
  ComplexPackagePlainProductCorePortable & {
    PlainProduct?: PlainProductPortable;
    ComplexPackage?: ComplexPackageMinPortable;
  };

export type ComplexPackagePlainProductWithProductAndPackageWithProductsAndFixedAttrsPortable =
  ComplexPackagePlainProductCorePortable & {
    Title?: string | null;
    Label?: string | null;
    Subtitle?: string | null;
    Suffix?: string | null;
    /** @format int32 */
    Position?: number;
    PlainProduct?: PlainProductPortable;
    ComplexPackage?: ComplexPackageWithProductsAndFixedAttrsPortable;
  };

export type ComplexPackagePlainProductWithProductPortable =
  ComplexPackagePlainProductCorePortable & {
    PlainProduct?: PlainProductPortable;
  };

export interface ComplexPackageQuantityOptionPortable {
  /** @format int32 */
  Quantity?: number;
  /** @format int32 */
  Position?: number;
  Title?: string | null;
  Subtitle?: string | null;
  Suffix?: string | null;
  OriginalPrice?: PriceComponent;
  /** @format int32 */
  DiscountPercent?: number;
  TotalPrice?: PriceComponent;
  Selected?: boolean;
}

export interface ComplexPackageSummary {
  /** @format int32 */
  Id?: number;
  Type?: ComplexPackageTypes;
  Name?: string | null;
  /** @format int32 */
  RemainedDays?: number;
}

export type ComplexPackageWithProductsAndFixedAttrsPortable =
  ComplexPackageCorePortable & {
    Badge?: string | null;
    Products?: ComplexPackagePlainProductWithProductPortable[] | null;
    FixedAttributes?: ProductAttributePortable[] | null;
  };

export interface ComplexPackagesOutput {
  ComplexPackages?: ComplexPackageItemPortable[] | null;
  ComplexPackageFeatures?: ComplexPackageFeaturePortable[] | null;
  Features?: FeaturePortable[] | null;
  CommonQuestions?: CommonQuestionPortable[] | null;
}

export interface CounselingFormFieldsPortable {
  /** @format int32 */
  CounselingFormId?: number;
  Fields?: any[] | null;
}

/** اطلاعات ارتباط بین مشاور و کالای مشاوره را نگه می‌دارد */
export type CounselingProductCounselorPortable = ProductAttributePortable & {
  /** @format uuid */
  CounselorId?: string;
  /** @format double */
  CounselorSharePercentSalary?: number;
  EffectSharePercentOnSuccessfulEvents?: boolean;
  /** @format int32 */
  CounselorShareFixedSalary?: number;
  OrderCompletionMessage?: string | null;
};

export type CounselorCompletePortable = CounselorCorePortable & {
  /** @format uuid */
  UserId?: string;
  WhyMe?: string | null;
  ShortDescription?: string | null;
  Description?: string | null;
  /** @format int32 */
  Position?: number | null;
  Link?: string | null;
  Cover?: string | null;
};

/** Represents consultant information of a user, migrated from `ConsultantInfo` */
export interface CounselorCorePortable {
  /** @format uuid */
  CounselorId?: string;
  /** @format int32 */
  NumericId?: number;
  Slug?: string | null;
  Name?: string | null;
  Degree?: string | null;
  Avatar?: string | null;
  Video?: string | null;
  /** @format double */
  Rate?: number;
}

export interface CounselorPresencePortable {
  Title?: string | null;
  Subtitle?: string | null;
  Period?: ZonedTimeInterval;
  /** نوع وقت رزرو را تعیین می کند */
  ReservationIntervalType?: ReservationIntervalType;
  /** انواع جلسات مورد پشتیبانی توسط مشاور */
  SupportedAppointmentTypes?: CounselorSupportedAppointmentTypes;
  Selected?: boolean;
}

export type CounselorPurchasePortable = CounselorCorePortable & {
  Experience?: string | null;
  PackageCategories?: string[] | null;
  Deactivated?: boolean;
  Online?: boolean;
};

export type CounselorSegmentPortable = CounselorCorePortable & {
  Deactivated?: boolean;
  Badge?: string | null;
  Description?: string | null;
  /** @format double */
  RateAverage?: number;
  /** @format int32 */
  RateCount?: number;
  Students?: string | null;
  YearOfExperience?: string | null;
  CounselingExperience?: string | null;
  Online?: boolean;
  /** @format int32 */
  Followers?: number;
  Following?: boolean;
  ReceiveNotification?: boolean;
};

export interface CustomizeComplexPackageInput {
  PackageConfig?: ComplexPackageCommonInput;
  CustomizedProducts?: CustomizedProductPortable[] | null;
  /** @format uuid */
  ConsulteeId?: string | null;
}

export interface CustomizeComplexPackageOutput {
  ComplexPackage?: ComplexPackageCustomizedPortable;
  Invoice?: PackedInvoiceCoreWithItemsPortable;
  ContractDayOptions?: ComplexPackageQuantityOptionPortable[] | null;
  Counselor?: CounselorPurchasePortable;
  Products?: CustomizingProductPortable[] | null;
  Component?: PurchaseComplexPackageComponent;
  Form?: CounselingFormFieldsPortable;
}

/** برای نگهداری تنظیمات کالای مشاوره‌ی چتی ارسالی از سمت کلاینت استفاده می‌شود */
export type CustomizedChatCounselingProductPortable =
  CustomizedProductPortable & object;

export type CustomizedCounselorManualDeliveryProductPortable =
  CustomizedProductPortable & object;

export type CustomizedPhoneCounselingProductPortable =
  CustomizedProductPortable & {
    /** نوع وقت رزرو را تعیین می کند */
    ReservationIntervalType?: ReservationIntervalType;
    PickedPeriod?: ZonedTimeInterval;
    /** @format int32 */
    FilledCounselingFormId?: number | null;
  };

export type CustomizedPlanningProductPortable = CustomizedProductPortable &
  object;

/**
 * اطلاعات پایه‌ای محصول را که کاربر انتخاب کرده نگه می‌دارد
 * مثلا اگر کاربر اطلاعات در بسته‌ی پیشرفته، کالاهای برنامه‌ریزی و مشاوره‌ی تلفنی را سفارشی کند، اطلاعات سفارشی هر کدام در یک نسخه از این کلاس ارسال می‌شود
 * این کلاس به ازای هر تنظیم دارای زیرکلاس متناظر است
 */
export interface CustomizedProductPortable {
  Type?: ProductType;
  /** @format int32 */
  ProductId?: number;
  FixedAttributeIds?: number[] | null;
  CustomizedAttributeIds?: number[] | null;
  DynamicAttributeIds?: number[] | null;
}

/** برای نگهداری تنظیمات کالای آزمون ارسالی از سمت کلاینت استفاده می‌شود */
export type CustomizedQuizProductPortable = CustomizedProductPortable & object;

export type CustomizingChatCounselingProductPortable =
  CustomizingProductPortable & object;

export type CustomizingCounselorAttribute =
  CustomizingProductAttributePortable & {
    /** @format uuid */
    CounselorId?: string;
  };

export type CustomizingCounselorManualDeliveryProductPortable =
  CustomizingProductPortable & object;

export type CustomizingDurationAttribute =
  CustomizingProductAttributePortable & {
    Title?: string | null;
    Subtitle?: string | null;
    OriginalPrice?: PriceComponent;
    /** @format int32 */
    DiscountPercent?: number;
    TotalPrice?: PriceComponent;
  };

export type CustomizingFixedQuantityAttribute =
  CustomizingProductAttributePortable & {
    Title?: string | null;
    Subtitle?: string | null;
    SecondSubtitle?: string | null;
    OriginalPrice?: PriceComponent;
    /** @format int32 */
    DiscountPercent?: number;
    TotalPrice?: PriceComponent;
  };

export type CustomizingGoalAttribute = CustomizingProductAttributePortable &
  object;

export type CustomizingPeriodicQuantityAttribute =
  CustomizingProductAttributePortable & {
    Title?: string | null;
    Suffix?: string | null;
    Subtitle?: string | null;
    SecondSubtitle?: string | null;
    OriginalPrice?: PriceComponent;
    /** @format int32 */
    DiscountPercent?: number;
    TotalPrice?: PriceComponent;
  };

export type CustomizingPhoneCounselingProductPortable =
  CustomizingProductPortable & {
    Presences?: CounselorPresencePortable[] | null;
  };

export type CustomizingPlanningProductPortable = CustomizingProductPortable &
  object;

/**
 * اطلاعات هر کدام از گزینه‌های هر محصول برای سفارشی‌سازی را نگه می‌دارد
 * مثلا اطلاعات هر مشاور را برای کالای جلسه‌ی تلفنی نگه داشته و به کاربر برمی‌گرداند
 * به همین صورت اطلاعات هر مدت زمان ممکن برای هر جلسه‌ی مشاوره‌ی تلفنی را نگه داشته و به کاربر برمی‌گرداند
 * این کلاس به ازای هر اتریبیوت دارای یک زیرکلاس منحصر‌به‌فرد است
 */
export interface CustomizingProductAttributePortable {
  Attribute?: ProductAttributeTypes;
  /** @format int32 */
  ProductAttributeId?: number;
  /** @format int32 */
  Position?: number;
  Selected?: boolean;
}

export interface CustomizingProductPortable {
  Type?: ProductType;
  /** @format int32 */
  ProductId?: number;
  Title?: string | null;
  Label?: string | null;
  Subtitle?: string | null;
  PickOptional?: boolean;
  PickDefault?: boolean;
  PickDisabled?: boolean;
  /** @format int32 */
  Position?: number;
  OriginalPrice?: PriceComponent;
  /** @format int32 */
  DiscountPercent?: number;
  TotalPrice?: PriceComponent;
  FixedAttributes?: {
    /**
     * اطلاعات هر کدام از گزینه‌های هر محصول برای سفارشی‌سازی را نگه می‌دارد
     * مثلا اطلاعات هر مشاور را برای کالای جلسه‌ی تلفنی نگه داشته و به کاربر برمی‌گرداند
     * به همین صورت اطلاعات هر مدت زمان ممکن برای هر جلسه‌ی مشاوره‌ی تلفنی را نگه داشته و به کاربر برمی‌گرداند
     * این کلاس به ازای هر اتریبیوت دارای یک زیرکلاس منحصر‌به‌فرد است
     */
    Counselor?: CustomizingProductAttributePortable;
    /**
     * اطلاعات هر کدام از گزینه‌های هر محصول برای سفارشی‌سازی را نگه می‌دارد
     * مثلا اطلاعات هر مشاور را برای کالای جلسه‌ی تلفنی نگه داشته و به کاربر برمی‌گرداند
     * به همین صورت اطلاعات هر مدت زمان ممکن برای هر جلسه‌ی مشاوره‌ی تلفنی را نگه داشته و به کاربر برمی‌گرداند
     * این کلاس به ازای هر اتریبیوت دارای یک زیرکلاس منحصر‌به‌فرد است
     */
    Duration?: CustomizingProductAttributePortable;
    /**
     * اطلاعات هر کدام از گزینه‌های هر محصول برای سفارشی‌سازی را نگه می‌دارد
     * مثلا اطلاعات هر مشاور را برای کالای جلسه‌ی تلفنی نگه داشته و به کاربر برمی‌گرداند
     * به همین صورت اطلاعات هر مدت زمان ممکن برای هر جلسه‌ی مشاوره‌ی تلفنی را نگه داشته و به کاربر برمی‌گرداند
     * این کلاس به ازای هر اتریبیوت دارای یک زیرکلاس منحصر‌به‌فرد است
     */
    Goal?: CustomizingProductAttributePortable;
    /**
     * اطلاعات هر کدام از گزینه‌های هر محصول برای سفارشی‌سازی را نگه می‌دارد
     * مثلا اطلاعات هر مشاور را برای کالای جلسه‌ی تلفنی نگه داشته و به کاربر برمی‌گرداند
     * به همین صورت اطلاعات هر مدت زمان ممکن برای هر جلسه‌ی مشاوره‌ی تلفنی را نگه داشته و به کاربر برمی‌گرداند
     * این کلاس به ازای هر اتریبیوت دارای یک زیرکلاس منحصر‌به‌فرد است
     */
    PeriodicQuantity?: CustomizingProductAttributePortable;
    /**
     * اطلاعات هر کدام از گزینه‌های هر محصول برای سفارشی‌سازی را نگه می‌دارد
     * مثلا اطلاعات هر مشاور را برای کالای جلسه‌ی تلفنی نگه داشته و به کاربر برمی‌گرداند
     * به همین صورت اطلاعات هر مدت زمان ممکن برای هر جلسه‌ی مشاوره‌ی تلفنی را نگه داشته و به کاربر برمی‌گرداند
     * این کلاس به ازای هر اتریبیوت دارای یک زیرکلاس منحصر‌به‌فرد است
     */
    FixedQuantity?: CustomizingProductAttributePortable;
  } | null;
  UpdatableAttributes?: {
    Counselor?: CustomizingProductAttributePortable[];
    Duration?: CustomizingProductAttributePortable[];
    Goal?: CustomizingProductAttributePortable[];
    PeriodicQuantity?: CustomizingProductAttributePortable[];
    FixedQuantity?: CustomizingProductAttributePortable[];
  } | null;
}

export type CustomizingQuizProductPortable = CustomizingProductPortable & {
  UpdateableAttributes?: {
    Counselor?: CustomizingProductAttributePortable[];
    Duration?: CustomizingProductAttributePortable[];
    Goal?: CustomizingProductAttributePortable[];
    PeriodicQuantity?: CustomizingProductAttributePortable[];
    FixedQuantity?: CustomizingProductAttributePortable[];
  } | null;
};

/** Used to display list of InvoiceItems grouped by ProductUnit */
export interface DisplayableInvoiceItemPortable {
  Name?: string | null;
  QuantityUnit?: string | null;
  /** @format int32 */
  Position?: number;
}

export interface ExamComponent {
  /** @format int32 */
  ExamId?: number | null;
  CustomExamTitle?: string | null;
  /** @format int32 */
  FieldId?: number | null;
  CustomFieldTitle?: string | null;
  /** @format int32 */
  BranchId?: number | null;
  /** @format int32 */
  ExamDateId?: number | null;
  /**
   * @format date
   * @example "2025-06-25"
   */
  CustomExamDate?: string | null;
}

export interface ExpiredClientVersionDetails {
  ClientType?: string | null;
  ExpiredClientVersionName?: string | null;
  /**
   * @format date
   * @example "2025-06-25"
   */
  Expiration?: string;
  Latest?: ClientVersionPortable;
}

export interface ExpiredClientVersionDetailsTypedExceptionResponse {
  Title?: string | null;
  Debug?: string | null;
  Type?: string | null;
  Details?: ExpiredClientVersionDetails;
}

export interface FeaturePortable {
  /** @format int32 */
  FeatureId?: number;
  Name?: string | null;
  /** @format int32 */
  Position?: number;
}

export interface FeedbackRateInput {
  /** @format int32 */
  RateId?: number;
  Operation?: FeedbackOperation;
  FeedbackType?: FeedbackType;
  /** @format uuid */
  ConsulteeId?: string | null;
}

export type FeedbackRateOutput = object;

export interface FilledCounselingFormField {
  /** @format int32 */
  CounselingFormFieldId?: number;
  /** شناسه‌ی گزینه‌ی انتخابی، یا آدرس فایل بارگذاری شده یا متن درج‌شده */
  Value?: string | null;
}

export type FixedQuantityAttributePortable = ProductAttributePortable & {
  Title?: string | null;
  Subtitle?: string | null;
  /** @format int32 */
  Quantity?: number;
};

export interface InstallmentPortable {
  /** @format int32 */
  Number?: number;
  /** @format int32 */
  Amount?: number;
  DisplayAmount?: PriceComponent;
  Title?: string | null;
}

export interface InvoiceCorePortable {
  /** @format int32 */
  InvoiceId?: number;
  Type?: InvoiceTypes;
  /** @format uuid */
  CustomerId?: string;
  OptionDiscount?: PriceComponent;
  Subtotal?: PriceComponent;
  CodeDiscount?: PriceComponent;
  StepDiscount?: PriceComponent;
  TotalDiscount?: PriceComponent;
  Total?: PriceComponent;
  WalletLocked?: PriceComponent;
  CancelCurrentPlan?: PriceComponent;
  Payable?: PriceComponent;
  BankRefundedAmount?: PriceComponent;
  BankRefundExecuted?: boolean;
  WalletRefundableRefundedAmount?: PriceComponent;
  WalletUnrefundableRefundedAmount?: PriceComponent;
  RefundedTotal?: PriceComponent;
  Title?: string | null;
  Description?: string | null;
  DiscountCode?: string | null;
  Status?: InvoiceStatus;
  /**
   * @format date
   * @example "2025-06-25"
   */
  Created?: string | null;
  /**
   * @format date
   * @example "2025-06-25"
   */
  Canceled?: string | null;
  /**
   * @format date
   * @example "2025-06-25"
   */
  Paid?: string | null;
  /**
   * @format date
   * @example "2025-06-25"
   */
  Expiration?: string;
  /**
   * @format date
   * @example "2025-06-25"
   */
  UsageDeadline?: string | null;
}

export type InvoiceCoreWithComplexPackagePortable = InvoiceCorePortable & {
  /** @format int32 */
  TotalDiscountPercent?: number;
  DownPayment?: PriceComponent;
  Installment?: PriceComponent;
  ComplexPackage?: ComplexPackageCorePortable;
  Installments?: InstallmentPortable[] | null;
};

export type InvoiceCoreWithItemsPortable = InvoiceCorePortable & {
  QuantityDiscount?: PriceComponent;
  WalletLockedAmount?: PriceComponent;
  CancelCurrentPlanAmount?: PriceComponent;
  Items?: InvoiceItemPortable[] | null;
};

export interface InvoiceInput {
  /** @format int32 */
  InvoiceId?: number;
  /** @format uuid */
  ConsulteeId?: string | null;
}

export interface InvoiceItemPortable {
  /** @format int32 */
  InvoiceItemId?: number;
  /** @format int32 */
  InvoiceId?: number;
  ProductType?: ProductType;
  /** @format int32 */
  ProductId?: number;
  Name?: string | null;
  Code?: string | null;
  /** @format int32 */
  DiscountByCode?: number;
  /** @format int32 */
  DiscountByQuantity?: number;
  /** @format int32 */
  DiscountTotal?: number;
  /** @format int32 */
  Quantity?: number;
  /** @format int32 */
  Amount?: number;
  /** @format int32 */
  UnitPrice?: number;
}

export type InvoiceItemWithInvoiceAndProductPortable = InvoiceItemPortable & {
  Product?: ManagerProductPortable;
  Invoice?: InvoiceCorePortable;
};

export type InvoiceItemWithInvoicePortable = InvoiceItemPortable & {
  Invoice?: InvoiceCorePortable;
};

export type InvoiceItemWithProductPortable = InvoiceItemPortable & {
  Product?: ManagerProductPortable;
};

export interface InvoiceOutput {
  Invoice?: InvoiceCoreWithComplexPackagePortable;
  /** Represents consultant information of a user, migrated from `ConsultantInfo` */
  Counselor?: CounselorCorePortable;
  PaymentMethods?: BankAccountPaymentMethodPortable[] | null;
}

export interface InvoicesOutput {
  /**
   * Count of total records matching this query
   * @format int32
   */
  TotalCount?: number | null;
  /**
   * Maximum count of available page based on total records count and size of each page
   * @format int32
   */
  PageCount?: number | null;
  Items?: InvoiceCorePortable[] | null;
  /** @format int32 */
  PageIndex?: number;
  /** @format int32 */
  PageSize?: number;
}

export interface ManagerCancelInvoiceInput {
  /** @format int32 */
  InvoiceId?: number;
  /** @format int32 */
  BankRefunded?: number;
  /** @format int32 */
  WalletRefundable?: number;
  /** @format int32 */
  WalletUnrefundable?: number;
  Comment?: string | null;
}

export type ManagerCancelInvoiceOutput = object;

export interface ManagerCancellingInvoiceOutput {
  Invoice?: CancellingInvoiceCoreWithItemsPortable;
}

export interface ManagerProductPortable {
  /** @format int32 */
  ProductId?: number;
  Name?: string | null;
  Code?: string | null;
  Description?: string | null;
  /** @example "2025-06-25T08:31:18.0989306\u002B03:30 Asia/Tehran" */
  Expiration?: string | null;
  Agreement?: string | null;
  /** @format int32 */
  TotalSalableQuantity?: number;
  /** @format int32 */
  MinQuantity?: number;
  Unit?: ProductUnit;
  UnitName?: string | null;
  ProductTypeId?: ProductType;
  ProductTypeName?: string | null;
  StackHolderType?: StackHolderType;
  /** @format uuid */
  StackHolderUserId?: string | null;
  /** @format double */
  StackHolderPercentage?: number;
  /** @format double */
  CancelPenaltyPercentage?: number;
  /** @format int32 */
  Position?: number;
  IsActive?: boolean;
}

export interface ObjectTypedExceptionResponse {
  Title?: string | null;
  Debug?: string | null;
  Type?: string | null;
  Details?: any;
}

export type PackedInvoiceCoreWithItemsAndComplexPackagePortable =
  InvoiceCorePortable & {
    QuantityDiscount?: PriceComponent;
    ComplexPackage?: ComplexPackageCorePortable;
    Items?: DisplayableInvoiceItemPortable[] | null;
  };

export type PackedInvoiceCoreWithItemsPortable = InvoiceCorePortable & {
  /** @format int32 */
  TotalDiscountPercent?: number;
  Items?: DisplayableInvoiceItemPortable[] | null;
};

export interface PageSeoDetail {
  Title?: string | null;
  Canonical?: string | null;
  Description?: string | null;
  Headline?: string | null;
  Meta?: PageSeoMetaDetails;
}

export interface PageSeoMetaDetails {
  Tags?: string[] | null;
  Follow?: boolean;
  Index?: boolean;
}

export interface PayInvoiceInput {
  /** @format int32 */
  InvoiceId?: number;
  /** @format int32 */
  BankAccountId?: number;
  PaymentMethod?: BankAccountPaymentMethod;
  /** @format uuid */
  ConsulteeId?: string | null;
}

export interface PayInvoiceOutput {
  Url?: string | null;
  Method?: HtmlFormMethods;
  KeyValues?: Record<string, string>;
}

export type PeriodicQuantityAttributePortable = ProductAttributePortable & {
  Title?: string | null;
  Subtitle?: string | null;
  /** @format int32 */
  Quantity?: number;
};

export interface PersistFilledCounselingFormPortable {
  /** @format int32 */
  CounselingFormId?: number;
  Fields?: FilledCounselingFormField[] | null;
}

/** اطلاعات ارتباط بین مشاور و کالای مشاوره را نگه می‌دارد */
export type PhoneCounselingProductDurationPortable =
  ProductAttributePortable & {
    Title?: string | null;
    Subtitle?: string | null;
    /** @format int32 */
    DurationInMinutes?: number;
  };

export type PlainExceptionResponse = ObjectTypedExceptionResponse & object;

export interface PlainProductPortable {
  /** @format int32 */
  PlainProductId?: number;
  Type?: ProductType;
  /** @format int32 */
  PrimaryPrice?: number;
  Title?: string | null;
  UnitName?: string | null;
}

/** براساس گزینه‌های انتخابی در سایر جاها، بسته، انتخاب و برگردانده می‌شود */
export interface PrepareComplexPackageInput {
  /** @format int32 */
  ComplexPackageId?: number;
  Exam?: ExamComponent;
  /** @format uuid */
  ConsulteeId?: string | null;
}

export interface PriceComponent {
  /** @format int32 */
  Amount?: number;
  Unit?: string | null;
  /** @format int32 */
  Coefficient?: number;
}

export interface ProductAttributePortable {
  /** @format int32 */
  ProductAttributeId?: number;
  /** @format int32 */
  PlainProductId?: number;
  Attribute?: ProductAttributeTypes;
  /** @format double */
  PriceCoefficient?: number;
  /** @format int32 */
  AdditivePrice?: number;
  /** @format double */
  DiscountCoefficient?: number;
  /** @format int32 */
  PricingPosition?: number;
  /** @format int32 */
  Position?: number;
  Selected?: boolean;
}

export type ProductFeedbackInput = object;

export interface ProductFeedbackOutput {
  /** اطلاعات جهت ایجاد نظر را نگهداری می کند */
  FeedbackNeeded?: ProductFeedbackPortable;
}

/** اطلاعات جهت ایجاد نظر را نگهداری می کند */
export interface ProductFeedbackPortable {
  /** Represents consultant information of a user, migrated from `ConsultantInfo` */
  Counselor?: CounselorCorePortable;
  /** @format int32 */
  UserProductId?: number;
  /** @format int32 */
  AppointmentId?: number | null;
  /** @format int32 */
  RatedQuantity?: number;
  Product?: string | null;
  Question?: string | null;
}

/** ارتباط بین کالا و هدف را نگه می‌دارد */
export type ProductGoalAttributePortable = ProductAttributePortable & {
  Goal?: ApplicantGoal;
};

export interface ProductUsageSegmentPortable {
  Title?: string | null;
  /** @format int64 */
  ApplicantCounselorId?: number | null;
  Items?: ProductsUsageItemPortable[] | null;
}

export interface ProductsUsageItemPortable {
  /** @format int32 */
  InvoiceItemId?: number;
  ProductType?: ProductType;
  /** @format int32 */
  ProductId?: number;
  Name?: string | null;
  Description?: string | null;
  Active?: boolean;
}

export interface ProductsUsageOutput {
  Cover?: string | null;
  Title?: string | null;
  Segments?: ProductUsageSegmentPortable[] | null;
}

export interface PurchaseComplexPackageComponent {
  /** @format int32 */
  ComplexPackageId?: number;
  /** @format int32 */
  GoalCounselorId?: number | null;
  Goal?: ApplicantGoal;
  GoalSelection?: ComplexPackageConfigurationSelection;
  Exam?: ExamComponent;
  /** @format uuid */
  CounselorId?: string | null;
  /** @format int32 */
  FilledFormId?: number | null;
  /** @format int32 */
  ContractDaysCount?: number | null;
}

export interface PurchaseComplexPackageInput {
  PurchaseConfig?: PurchaseComplexPackageComponent;
  CustomizedProducts?: CustomizedProductPortable[] | null;
  FilledForm?: PersistFilledCounselingFormPortable;
  /** @format uuid */
  ConsulteeId?: string | null;
}

export interface PurchaseComplexPackageOutput {
  /** @format int32 */
  InvoiceId?: number;
}

export interface RatePortable {
  /** @format int32 */
  RateId?: number;
  From?: string | null;
  Description?: string | null;
  Avatar?: string | null;
  /** @format double */
  Rate?: number | null;
  Created?: string | null;
  Subject?: string | null;
  Feedback?: FeedbackType;
  Reply?: ReplyRatePortable;
}

export interface RatePortableInt32LimitedCountPreview {
  Identifier?: string | null;
  Title?: string | null;
  /** @format int32 */
  Total?: number;
  HasMore?: boolean;
  /** @format int32 */
  EndCursor?: number | null;
  Items?: RatePortable[] | null;
}

export interface RateUserProductInput {
  /** @format uuid */
  CounselorId?: string;
  /** @format int32 */
  UserProductId?: number;
  /** @format int32 */
  AppointmentId?: number | null;
  /** @format int32 */
  RatedQuantity?: number;
  /** @format double */
  Rate?: number;
  Comment?: string | null;
}

export type RateUserProductOutput = object;

export interface RatesOutput {
  /** Returning Items */
  Items?: RatePortable[] | null;
  /**
   * corresponding to the first cursor of Items
   * @format int32
   */
  StartCursor?: number | null;
  /**
   * corresponding to the last cursor of Items
   * @format int32
   */
  EndCursor?: number | null;
  /** is used to indicate whether more edges exist following the set defined by the clients arguments */
  HasNext?: boolean;
  /** is used to indicate whether more edges exist prior to the set defined by the clients arguments. */
  HasPrevious?: boolean;
  /**
   * Count of total records matching this query
   * @format int32
   */
  TotalCount?: number | null;
}

export interface ReplyRatePortable {
  /** @format int32 */
  RateId?: number;
  Description?: string | null;
}

export type SkipRateUserProductsInput = object;

export type SkipRateUserProductsOutput = object;

export interface SortOrder {
  /** Column to sort */
  Column?: string | null;
  Direction?: SortOrders;
  /**
   * Position of this sort through others
   * @format int32
   */
  Position?: number;
}

export interface StackHolderPaymentPortable {
  /** @format int32 */
  StackHolderPaymentId?: number;
  Description?: string | null;
  Total?: PriceComponent;
  Subtotal?: PriceComponent;
  Reward?: PriceComponent;
  Penalty?: PriceComponent;
  Status?: StackHolderPaymentStatus;
  /** @example "2025-06-25T08:31:18.0989306\u002B03:30 Asia/Tehran" */
  Paid?: string | null;
  /**
   * @format date-time
   * @example "2025-06-25T05:01:18.0989306Z"
   */
  Created?: string;
}

export interface StackHolderPaymentsOutput {
  /** Returning Items */
  Items?: StackHolderPaymentPortable[] | null;
  /**
   * corresponding to the first cursor of Items
   * @format int32
   */
  StartCursor?: number | null;
  /**
   * corresponding to the last cursor of Items
   * @format int32
   */
  EndCursor?: number | null;
  /** is used to indicate whether more edges exist following the set defined by the clients arguments */
  HasNext?: boolean;
  /** is used to indicate whether more edges exist prior to the set defined by the clients arguments. */
  HasPrevious?: boolean;
  /**
   * Count of total records matching this query
   * @format int32
   */
  TotalCount?: number | null;
}

export interface StartFreeComplexPackageInput {
  /** @format uuid */
  ConsulteeId?: string | null;
}

export interface StartFreeComplexPackageOutput {
  CurrentComplexPackage?: ComplexPackageSummary;
}

export type TariffComplexPackagesInput = object;

export interface TariffComplexPackagesOutput {
  ComplexPackages?: ComplexPackageItemPortable[] | null;
  ComplexPackageFeatures?: ComplexPackageFeaturePortable[] | null;
  Features?: FeaturePortable[] | null;
  CommonQuestions?: CommonQuestionPortable[] | null;
}

export interface UseManualDeliveryUserProductsInput {
  /** @format int32 */
  UsedQuantity?: number;
  UserProductIds?: number[] | null;
}

export type UseManualDeliveryUserProductsOutput = object;

export interface UseOnDemandUserProductInput {
  /** @format int32 */
  UsedQuantity?: number;
  /** @format int32 */
  UserProductId?: number;
  RelatedEntityType?: UserProductRelatedEntityType;
  /** @format int32 */
  RelatedEntityId?: number | null;
}

export type UseOnDemandUserProductOutput = object;

export interface UserCorePortable {
  /** @format uuid */
  ID?: string;
  Fullname?: string | null;
  TrackingId?: string | null;
  Avatar?: string | null;
}

export interface ValidationProblemDetails {
  Type?: string | null;
  Title?: string | null;
  /** @format int32 */
  Status?: number | null;
  Detail?: string | null;
  Instance?: string | null;
  Errors?: Record<string, string[]>;
  [key: string]: any;
}

export interface WalletBalanceOutput {
  Total?: PriceComponent;
  RefundableAmount?: PriceComponent;
  UnrefundableAmount?: PriceComponent;
}

export interface ZonedTimeInterval {
  /** @example "2025-06-25T08:31:18.0989306\u002B03:30 Asia/Tehran" */
  Start?: string;
  /** @example "25:01:01.001" */
  Duration?: string;
  /** @example "2025-06-25T08:31:18.0989306\u002B03:30 Asia/Tehran" */
  End?: string;
}

export interface PostV0ManagerCoreInvalidateClientVersionsCacheBooleanCascadeParams {
  cascade?: boolean;
}

export interface PostPaymentCallbackPaymentIdInt32PaymentIdDictionaryStringStringParametersPayload {
  parameters?: Record<string, string>;
}

export interface GetPaymentCallbackGetPaymentIdInt32PaymentIdDictionaryStringStringParametersParams {
  parameters?: Record<string, string>;
  /** @format int32 */
  paymentId: number;
}

export interface GetV0StackHolderQueryStackHolderPaymentsInt32CountNullableInt32StartPointStringDirectionNullableGuidFilterCounselorIdParams {
  /**
   * تعداد اقلام دریافتی از صفحه
   * تعداد پیش فرض 25 می باشد
   * @format int32
   * @min 1
   * @max 999
   */
  Count?: number;
  /**
   * محل شروع برای حرکت رو به جلو یا عقب در صورتی که محل شروع تعیین نشود بسته به جهت
   * به داد تعیین شده از ابتدا یا انتها خوانده میشود
   * @format int32
   */
  StartPoint?: number;
  /** جهت حرکت رو به جلو یا عقب را مشخص می کند که پیش فرض رو به جلو می باشد */
  Direction?: InfiniteScrollDirection;
  /**
   * شناسه مشاور
   * @format uuid
   */
  "Filter.CounselorId"?: string;
}

export interface GetV0StoreQueryTariffComplexPackagesTariffComplexPackagesInputInputParams {
  input?: TariffComplexPackagesInput;
}

export interface GetV0StoreQueryInvoicesNullableGuidConsulteeIdSortOrderSortOrdersBooleanQueryCountInt32PageIndexInt32PageSizeNullableGuidFilterCustomerIdStringFilterStatusInvoiceStatusFilterStatusesStringFilterTypeBooleanFilterExcludeDependentRefundsNullableDateTimeFilterExcludeExpiredPendingsParams {
  SortOrders?: SortOrder[];
  /** If was true, queries for total count of records. If was false, skips count of total records */
  QueryCount?: boolean;
  /**
   * Index of requested page (started from 1, NOT 0)
   * @format int32
   * @min 1
   * @max 2147483647
   */
  PageIndex?: number;
  /**
   * Maximum rows to be returned in each page
   * According to excel output, maximum page size increased to 9999
   * @format int32
   * @min 1
   * @max 9999
   */
  PageSize?: number;
  /**
   * شناسه مشتری
   * @format uuid
   */
  "Filter.CustomerId"?: string;
  /** وضعیت فاکتور */
  "Filter.Status"?: InvoiceStatus;
  /** وضعیت فاکتور */
  "Filter.Statuses"?: InvoiceStatus[];
  /** نوع فاکتور */
  "Filter.Type"?: InvoiceTypes;
  "Filter.ExcludeDependentRefunds"?: boolean;
  /** @format date-time */
  "Filter.ExcludeExpiredPendings"?: string;
}

export interface GetV0StoreQueryProductFeedBackProductFeedbackInputInputParams {
  input?: ProductFeedbackInput;
}

export interface GetV0StoreQueryRatesInt32CountNullableInt32StartPointStringDirectionGuidCounselorIdNullableInt32ComplexPackageIdNullableGuidConsulteeIdParams {
  /** @format int32 */
  Count?: number;
  /** @format int32 */
  StartPoint?: number;
  /** جهت حرکت را تعیین می کند */
  Direction?: InfiniteScrollDirection;
  /** @format uuid */
  CounselorId?: string;
  /** @format int32 */
  ComplexPackageId?: number;
}

export interface GetV0StoreQueryProductsUsageInt32InvoiceIdNullableGuidConsulteeIdParams {
  /** @format int32 */
  InvoiceId?: number;
}

export interface GetV0StoreQueryApplicantActiveProductsGuidApplicantIdParams {
  /** @format uuid */
  ApplicantId?: string;
}

export interface GetV0StoreQueryManagerCancellingInvoiceInt32InvoiceIdNullableDoublePenaltyPercentParams {
  /** @format int32 */
  InvoiceId?: number;
  /** @format double */
  PenaltyPercent?: number;
}

export interface GetV0StoreQueryComplexPackageStringComplexPackageSlugStringCounselorSlugNullableGuidConsulteeIdParams {
  ComplexPackageSlug?: string;
  CounselorSlug?: string;
}
